import { render, staticRenderFns } from "./kyc-withdraw-detail.vue?vue&type=template&id=180aa570&scoped=true&"
import script from "./kyc-withdraw-detail.vue?vue&type=script&lang=js&"
export * from "./kyc-withdraw-detail.vue?vue&type=script&lang=js&"
import style0 from "./kyc-withdraw-detail.vue?vue&type=style&index=0&id=180aa570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180aa570",
  null
  
)

export default component.exports